<template>
  <div>
    <div class="input-group">
      <input
        ref="inputctrl"
        type="text"
        class="form-control form-control-sm"
        aria-describedby="btnGroupAddon"
        v-model="val"
        @focus="enterRow()"
        @blur="leaveRow()"
        @keyup="onKeyDown"
        autocomplete="off"
      />
      <div class="input-group-append">
        <div class="input-group-text" id="btnGroupAddon" v-on:click="showAll()" title="Visa alla">
          <!-- <i class="fa fa-sort-desc fa-xs mt-4"></i> -->
          <!-- <b-icon class="arrow-down" /> -->
          <b-icon-chevron-bar-expand />
        </div>
      </div>
    </div>
    
      <ul class="list-group" style="position:absolute;z-index:1" v-if="entered">
        <div class="scroll" style="height: 200px">
        <li
          v-bind:class="{ active: n == currItem }"
          class="list-group-item"
          v-for="n in getOptions(val,currShowAll)"
          :key="n.value"
          @keyup="onKeyDown"
          @click="selectRow(n);"
          @mouseover="setCurrent(n)"
        >{{n.text}}</li>
        </div>
      </ul>
    
  </div>
</template>

<script>
export default {
  name: "autocomp",
  props: { value: [String, Number], datasource: Array },
  data() {
    return {
      val: null,
      entered: false,
      currItem: null,
      currShowAll: false,
    };
  },
  watch: {
    value() {
      console.log("value changed:" + JSON.stringify(this.value));
      this.val = this.value;
    },
  },
  created() {
    console.log("autocomp created");
    console.log(this.value);
    this.val = this.value;
  },
  methods: {
    Focus() {
      this.$refs.inputctrl.$el.focus();
    },
    getOptions(sf, displayAll) {
      var res = [];
      if (this.datasource) {
        var searchFor = "";
        console.log(sf);
        if (sf) searchFor = sf.toString().toLowerCase();
        this.datasource.map((p) => {
          if (
            displayAll ||
            (searchFor != "" && p.text.toLowerCase().indexOf(searchFor) >= 0)
          )
            res.push(p);
        });

        return res;
      }
    },
    showAll() {
      this.enterRow();
      this.currShowAll = !this.currShowAll;
    },
    enterRow() {
      console.log("enter");
      this.entered = true;
    },
    leaveRow() {
      console.log("leave");
      if (this.currItem) {
        this.selectRow(this.currItem);
        this.currItem = null;
      }

      this.entered = false;
      this.currShowAll = false;
    },
    selectRow(v) {
      this.val = v.value;
      console.log("selectRow");
      this.currShowAll = false;
      this.currItem = null;
      this.$emit("input", v.value);
      this.val = null;
    },
    onKeyDown(e) {
      var char = event.which || event.keyCode;
      console.log(char);
      switch (char) {
        case 40: //"ArrowDown": //ArrowDown
          if (!this.val || this.val == "") {
            if (!this.currShowAll) {
              this.currShowAll = true;
              this.setCurrent(this.getOptions(this.val, this.currShowAll)[0]);
              break;
            }
          }
          this.stepCurrent(1);
          e.preventDefault();
          break;
        case 38: //"ArrowUp": //ArrowUp
          this.stepCurrent(-1);
          e.preventDefault();
          break;
        case 13: //Enter
          if (this.currItem) {
            this.selectRow(this.currItem);
            e.preventDefault();
          }
          break;
        default:
          this.stepCurrent(0);
          this.currShowAll = false;
          if (this.val) {
            this.$emit("filter", this.val);
          }
          break;
      }
    },
    stepCurrent(steps) {
      var opts = this.getOptions(this.val, this.currShowAll);
      if (!opts || opts.length == 0) {
        this.currItem = null;
        return;
      }

      if (!this.currItem) {
        this.currItem = opts[0];
        return;
      }

      var idx = opts.findIndex((x) => x.value === this.currItem.value);
      if (idx < 0) {
        this.currItem = opts[0];
        return;
      }

      idx += steps;
      if (idx >= opts.length) idx = 0;
      if (idx < 0) idx = opts.length - 1;

      this.currItem = opts[idx];
    },
    setCurrent(c) {
      this.currItem = c;
    },
  },
};
</script>

<style scoped>
.list-group-item {
  padding: 0;
  /* background-color: gray; */
}
.scroll {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>